import React, { memo } from 'react'
import { string } from 'prop-types'
import { useTheme } from 'emotion-theming'

export const Login = memo(({ variant = 'primary' }) => {
	const { colors } = useTheme()
	let strokeColor = colors.primary

	switch (variant) {
		case 'hover':
			strokeColor = colors.secondary
			break
		case 'secondary':
			strokeColor = colors.white
			break
		case 'primary':
		default:
			strokeColor = colors.primary
	}

	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 31.1 31.1"
			style={{ enableBackground: 'new 0 0 31.1 31.1' }}
			xmlSpace="preserve"
		>
			<path
				fill="none"
				stroke={strokeColor}
				strokeWidth={2.1}
				strokeMiterlimit={10}
				d="M15.6,30c-8,0-14.4-6.5-14.4-14.4c0-8,6.5-14.4,14.4-14.4c8,0,14.4,6.5,14.4,14.4S23.5,30,15.6,30z"
			/>
			<path
				fill="none"
				stroke={strokeColor}
				strokeWidth={2.1}
				strokeMiterlimit={10}
				d="M15.6,8.6c-2.4,0-4.4,2-4.4,4.4v2.3c0,2.4,2,4.4,4.4,4.4s4.4-2,4.4-4.4V13C20,10.6,18,8.6,15.6,8.6z"
			/>
			<path
				fill="none"
				stroke={strokeColor}
				strokeWidth={2.1}
				strokeLinecap="round"
				strokeMiterlimit={10}
				d="M4.9,24.3c0-3.4,4.1-3.4,5.8-5.5"
			/>
			<path
				fill="none"
				stroke={strokeColor}
				strokeWidth={2.1}
				strokeLinecap="round"
				strokeMiterlimit={10}
				d="M19.9,19c1.7,2.1,5.8,2,5.8,5.4"
			/>
		</svg>
	)
})

Login.propTypes = {
	color: string,
}
